const ACTION = 'USER_LOGOUT';

const actionCreator = () => ({ type: ACTION });

actionCreator.ACTION = ACTION;

export default actionCreator;




// WEBPACK FOOTER //
// ./src/Login/ActionCreator/logoutAction.js